import { Component, Input, OnInit, EventEmitter } from '@angular/core';
import { Globals } from '../shared/globals';
import { TextService } from '../shared/text.service';

@Component({
  selector: 'app-realizations',
  templateUrl: './realization.component.html',
  styleUrls: ['./course.component.css']
})
export class RealizationComponent implements OnInit {

  @Input() id: any;
  @Input() realizations: any;
  @Input() past = false;


  actions: EventEmitter<any|any> = new EventEmitter <any|any>();
  actions2: EventEmitter<any|any> = new EventEmitter <any|any>();

  errorMessage: any;
  // Otsikot
  showMore: any;
  showLess: any;
  crossStudyTooltip: any;

  showAllEvents = false;
  showAllRealizationEvents: boolean[] = [];
  showAllGroupEvents: boolean[] = [];

  myDate = new Date();

  constructor(
    public globals: Globals,
    private textService: TextService
  ) {}

  ngOnInit(): void {



    this.textService.getText('show.more').subscribe(
      value => this.showMore = value,
      error => this.errorMessage = <any>error
    );

    this.textService.getText('show.less').subscribe(
      value => this.showLess = value,
      error => this.errorMessage = <any>error
    );

    this.textService.getText('cross.study.tooltip').subscribe(
      value => this.crossStudyTooltip = value,
      error => this.errorMessage = <any>error
    );

  }

  showGroupEvents(index: number): boolean {
    return this.showAllGroupEvents[index];
  }

  showRealizationEvents(index: number): boolean {
    return this.showAllRealizationEvents[index];
  }

  collapse(event: any, j:any) {
    if (event.key === "Enter") {
      //event.stopPropagation();
      this.actions.emit({action:"collapsible", params:['open', j]}); 
     // this.actions2.emit({action:"collapsible", params:['open', j]}); 
    }
  }

  collapse2(event:any, j:any) {
    if (event.key === "Enter") {
      event.stopPropagation();
      this.actions2.emit({action:"collapsible", params:['open', j]}); 
    }
  }

  toggleRealizationEvents(index: any) {
    this.showAllRealizationEvents[index] ?
      this.showAllRealizationEvents[index] = false : this.showAllRealizationEvents[index] = true;
  }

  toggleRealizationEvents2(event:any , index: any) {
    if (event.key === "Enter") {
      event.stopPropagation();
      this.toggleRealizationEvents(index);
    }
  }

  toggleGroupEvents(index: any) {
    this.showAllGroupEvents[index] ? this.showAllGroupEvents[index] = false : this.showAllGroupEvents[index] = true;
  }

  toggleGroupEvents2(event:any , index: any) {
    if (event.key === "Enter") {
      event.stopPropagation();
      this.toggleGroupEvents(index);
    }
  }

}

